import {useState} from 'react';
import './layout.scss';
import Header from "../../components/User_Side/header/header";
import Footer from "../../components/User_Side/footer/Footer";
import About from "./About/About";
import Testimony from "./Testimony/Testimony";
import LegalInformation from "./LegalInformation/LegalInformation";
import { Element } from 'react-scroll'
import Home from "./Home/Home";
import Cart from "../../hooks/cart/Cart";
import {apiClient} from "../../api/apiClient";
import CategoryPage from "./CategoryPage/CategoryPage";
import Workshop from "./Workshop/Workshop";
import Specials from "./Specials/Specials";
import {useCategories} from "../../hooks/useCategories";
import {Category} from "../../interfaces/interfaces";
import {useMediaQuery} from "../../hooks/useMediaQuery";


const Layout = () => {
    const [activePage, setActivePage] = useState<string | null>(null);
    const [legalInformation, setLegalInformation] = useState<boolean>(false);
    const [modalNewsletter, setModalNewsletter] = useState(false);
    const [submittedNewsletter, setSubmittedNewsletter] = useState(false);
    const [modalWorkshop, setModalWorkshop] = useState(false);
    const [submittedWorkshop, setSubmittedWorkshop] = useState(false);
    const [modalSpecials, setModalSpecials] = useState(false);
    const [submittedSpecials, setSubmittedSpecials] = useState(false);
    const [modalTestimony, setModalTestimony] = useState(false);
    const [submittedTestimony, setSubmittedTestimony] = useState(false);
    const isDesktop = useMediaQuery(768);
    const [menuOpen, setMenuOpen] = useState(isDesktop);
    const categories: Category[] = useCategories()

    return (
        <div className={"appLayout"}>
            <div className={"top"}>
                <Header
                    props={{
                        activePage: activePage,
                        setActivePage: setActivePage,
                        menuOpen: menuOpen,
                        modal: modalNewsletter,
                        setModal: setModalNewsletter,
                        submitted: submittedNewsletter,
                        setSubmitted: setSubmittedNewsletter,
                    }} />
            </div>
            {activePage === null && (
                <button className={"burger"} onClick={() => setMenuOpen(!menuOpen)}>
                    ☰
                </button>
            )}
            <div className={"body"}>
                <Element id="home" name="about"><Home/></Element>
                <Element id="about" name="about"><About/></Element>
                <Element id="specials" name="specials"><Specials props={{
                    modal: modalSpecials,
                    setModal: setModalSpecials,
                    submitted: submittedSpecials,
                    setSubmitted: setSubmittedSpecials,
                }}/>
                </Element>
                <Element id="workshop" name="workshop"><Workshop props={{
                    modal: modalWorkshop,
                    setModal: setModalWorkshop,
                    submitted: submittedWorkshop,
                    setSubmitted: setSubmittedWorkshop,
                }}/>
                </Element>
                <Element id="testimony" name="testimony"><Testimony props={{
                    modal: modalTestimony,
                    setModal: setModalTestimony,
                    submitted: submittedTestimony,
                    setSubmitted: setSubmittedTestimony
                }}/>
                </Element>
                {legalInformation && (<Element id="legal" name="legal"><LegalInformation/></Element>)}
            </div>
            {activePage && (
                <div className="fullscreen-page">
                    <button className="close-btn" onClick={() => setActivePage(null)}>✕</button>
                    <div className="shopping-section">
                        <CategoryPage
                            key={activePage}
                            props={{
                                category:categories.find(cat => cat.name.toLowerCase() === activePage)
                            }}
                            />
                    </div>
                </div>
            )}
            <Cart/>
            <Footer props={{
                menuOpen: menuOpen,
                legalInformation: legalInformation,
                setLegalInformation: setLegalInformation
            }}/>
        </div>
    );
};

export default Layout;

